import adminApi from "./adminApi";

export async function runBacktest(payload) {

    const { data } =
        await adminApi.post(
            "/algorithm/backtest",
            payload
        );

    return data;
}